import appAxios from 'voxguru-v1/api/appAxios';

const makePostRequest = async (endpoint, body) => {
  const { data } = await appAxios.post(endpoint, body);
  return data;
};

export default makePostRequest;
